'use strict';

const ajax = require('superagent');

function ConsentKeeperMixin () {
  var consentKeeper = {
    url: '',
    apiKey: ''
  };

  this.setConsentKeeper = function (url, apiKey) {
    consentKeeper.url = url;
    consentKeeper.apiKey = apiKey;
  };

  this.sendConsent = function(consent) {
    var _this = this;
    ajax.post(consentKeeper.url)
      .set({ 'x-api-key': consentKeeper.apiKey })
      .send(consent)
      .then(function (response) {
        _this.successConsent(response);
      })
      .catch(function (error) {
        _this.errorConsent(error);
      });
  };

  this.successConsent = function (response) {
    throw 'Method not implemented';
  };

  this.errorConsent = function (error) {
    throw 'Method not implemented';
  };

  return this;
}

module.exports = ConsentKeeperMixin;



//////////////////
// WEBPACK FOOTER
// ./_js/mixins/consent-keeper.js
// module id = 18
// module chunks = 0 1 2